import AUDIO_USAGES from '@UI/Pages/Administration/AiEngines/audioUsages';
import {
	REALTIME_DELIVERY_MODE,
	isRealtimeFamily,
} from '@UI/Pages/Administration/AiEngines/realtimeDeliveryRules';

/** The minimal shape this constraint reads. */
type RealtimeDeliveryShape = {
	readonly usages: string[];
	readonly family: string | null;
};

/**
 * Generic over the minimal shape it reads (`guides/forms.md` §1.1). Real-time delivery is only valid
 * for a model carrying an audio usage whose family some provider can serve in real time; every other
 * delivery mode passes. The provider kind is not checked here: the server is the authority on it.
 */
function isRealtimeDeliveryCompatibleWithFamily<T extends RealtimeDeliveryShape>(
	value: string | null,
	formData: T,
): boolean {
	const hasAudioUsage = formData.usages.some((usage) => AUDIO_USAGES.includes(usage));

	if (!hasAudioUsage || value !== REALTIME_DELIVERY_MODE) {
		return true;
	}

	return isRealtimeFamily(formData.family);
}

export default isRealtimeDeliveryCompatibleWithFamily;
